
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/page/[pageNumber]",
      function () {
        return require("private-next-pages/blog/page/[pageNumber].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/page/[pageNumber]"])
      });
    }
  